<script lang="ts">
	import Header from '../../components/Header.svelte';
	import Footer from '../../components/Footer.svelte';
	import { snackbar, viewport } from '@wiseed/wikit';
	import { onMount } from 'svelte';
	import { isSidebarOpen } from '@app/stores/sidebar';
	import { tick } from 'svelte';
	import { attrValue } from '@wiseed/wikit';
	import { beforeNavigate } from '$app/navigation';
	import { page } from '$app/stores';
	import { logError } from '@app/utils/log';
	import { updateNotificationStore } from '@app/stores/notifications';

	/* START BOTTOM NAV */
	let bottomNav = null;

	const loadBottomNav = async (): Promise<void> => {
		({ default: bottomNav } = await import('@app/components/nav/BottomNav.svelte'));
	};

	$: if ($viewport.isTablet || $viewport.isMobile) {
		loadBottomNav();
	} else {
		bottomNav = null;
	}

	let bottomNavButtonMenu: HTMLButtonElement;
	/* END BOTTOM NAV */

	const watchSideBar = () => {
		isSidebarOpen.subscribe((isOpen) => {
			const { documentElement: htmlEl } = document;
			isOpen
				? htmlEl.classList.add('overflow-y-hidden')
				: htmlEl.classList.remove('overflow-y-hidden');
		});
	};

	onMount(async () => {
		watchSideBar();
	});
	$: updateNotificationStore($page?.data);

	let transitionHeight: string;
	let transitionOverflow: string;
	let transitionShadow: string;
	let ctn: HTMLDivElement;
	let bodyYPosition: number;
	let transitionBodyYPosition: number;
	let currentSlug: string | undefined;
	let nextSlug: string | undefined;

	beforeNavigate((navigation) => {
		currentSlug = navigation.from?.params?.slug;
		nextSlug = navigation.to?.params?.slug;
	});

	$: if ($page.data?.dataFetchingErrorMessage) {
		snackbar.danger($page.data?.dataFetchingErrorMessage);
		logError($page.data?.dataFetchingErrorMessage);
	}
</script>

<svelte:window bind:scrollY={bodyYPosition} />

<Header toggleSidebarRefs={[bottomNavButtonMenu]} />

<div
	bind:this={ctn}
	class="transition-all duration-500 {$isSidebarOpen
		? 'scale-75 -translate-x-3/4 rounded-lg '
		: ''} {attrValue([transitionHeight, transitionOverflow, transitionShadow])}"
	on:transitionstart={(e) => {
		if (e.target !== ctn) return;
		transitionHeight = 'h-screen';
		transitionOverflow = 'overflow-hidden';
		if ($isSidebarOpen) {
			transitionBodyYPosition = bodyYPosition;
			ctn.scrollTop = bodyYPosition;
		} else {
			if (currentSlug !== nextSlug) {
				ctn.scrollTop = 0;
			}
		}
	}}
	on:transitionend={async (e) => {
		if (e.target !== ctn) return;
		if (!$isSidebarOpen) {
			transitionHeight = 'h-auto';
			transitionOverflow = 'overflow-visible';
			if (currentSlug === nextSlug) {
				await tick();
				bodyYPosition = transitionBodyYPosition;
			}
		} else {
			transitionShadow = 'shadow-lg border border-grey-light';
		}
	}}
>
	<main>
		<slot />
	</main>

	<Footer />
</div>
<svelte:component this={bottomNav} bind:bottomNavButtonMenu />

<style lang="postcss">
	main {
		@apply pb-[3.5rem] lg:pb-0 flex flex-col min-h-screen;
	}
</style>
